export default "__VITE_ASSET__DLQ5nZlw__"